// api.js
import axios from 'axios'
import router from '@/router'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const requestAction = async (options) => {
  try {
    options.headers = {
      'token': `Djkx ${localStorage.getItem('token')}`,
      ...options.headers
    }
    const response = await instance(options)
    const responseData = response.data
    if (responseData.code === 203 || responseData.msg === 'Invalid Token') {
      responseData.msg = '请重新登录'
      handleTokenExpired()
    }
    return responseData
  } catch (error) {
    throw error
  }
}

function handleTokenExpired () {
  setTimeout(() => {
    router.push({ name: 'Login' })
  }, 500)
}

export const login = params => {
  const options = {
    url: '/api/app/v1/login',
    data: params,
    method: 'POST'
  }
  return requestAction(options)
}

export const password = params => {
  const options = {
    url: '/api/app/v1/password',
    data: params,
    method: 'POST'
  }
  return requestAction(options)
}

export const userInfo = params => {
  const options = {
    url: '/api/app/v1/user-info',
    method: 'GET'
  }
  return requestAction(options)
}

export const userOrders = params => {
  const options = {
    url: '/api/app/v1/user-orders',
    data: params,
    method: 'POST'
  }
  return requestAction(options)
}

export const addDeposit = params => {
  const options = {
    url: '/api/app/v1/add-deposit',
    data: params,
    method: 'POST'
  }
  return requestAction(options)
}

export const settlementOrder = params => {
  const options = {
    url: '/api/app/v1/settlement-order',
    data: params,
    method: 'POST'
  }
  return requestAction(options)
}

export const withdraw = params => {
  const options = {
    url: '/api/app/v1/withdraw',
    data: params,
    method: 'POST'
  }
  return requestAction(options)
}

export const createOrder = params => {
  const options = {
    url: '/api/app/v1/create-order',
    data: params,
    method: 'POST'
  }
  return requestAction(options)
}



// WEBPACK FOOTER //
// ./src/common/api.js